/* A screen's computed state (docs/API.md → Enums, ScreenStatus): a heartbeat under 2 min is online. */
export enum ScreenStatus {
    Online   = 'online',
    Offline  = 'offline',
    Unpaired = 'unpaired',
}

/* Orientation of a screen, a design and a template (docs/API.md → Enums). */
export enum ScreenOrientation {
    Landscape = 'landscape',
    Portrait  = 'portrait',
}

export const ORIENTATIONS: ScreenOrientation[] = [ScreenOrientation.Landscape, ScreenOrientation.Portrait]

/* Why a pending display is in a tenant's list (docs/API.md → Pending screens, `matched_by`). */
export enum PendingMatch {
    Tenant  = 'tenant',
    Network = 'network',
}
